<template>

    <div>
        <div class="log-page col-12">
            <div class="mainlog-body col-12">
                <MainLog
                        :options="options"
                        @change="changeDropDown"
                />
            </div>
            <div class="log-details  col-12">
                <LogDetails :details="details" :key="details.id"/>
            </div>
        </div>
    </div>
</template>

<script>
    import MainLog from '@/components/logs/MainLog';
    import LogDetails from "./LogDetails";
    import {getLogListFile, getLogDetail} from "../shared/services/log.service";

    export default {
        name: 'logs',
        components: {LogDetails, MainLog},
        data() {
            return {
                options: [],
                details: [],
            }
        },
        created(){
            getLogListFile().then(response => {
                this.options=response.data;
            });
        },
        methods: {
            changeDropDown(val) {
                console.log(val.filename);
                getLogDetail(val.filename).then(response => {
                    this.details=response.data;
                });
            }

        },
    };
</script>

<style scoped>
    @import '../../assets/style/css/logs.css';
</style>
